import { useEffect, useRef } from 'react';

export const useScrollEndPonyfill = (element: HTMLElement | null, callback: () => void) => {
  const scrollEndTimer = useRef<number | null>(null);
  useEffect(() => {
    const fallback = () => {
      if (scrollEndTimer.current !== null) {
        clearTimeout(scrollEndTimer.current);
      }
      scrollEndTimer.current = window.setTimeout(callback, 100);
    };

    if ('onscrollend' in window) {
      element?.addEventListener('scrollend', callback);
    } else {
      element?.addEventListener('scroll', fallback);
    }

    return () => {
      if ('onscrollend' in window) {
        element?.removeEventListener('scrollend', callback);
      } else {
        element?.removeEventListener('scroll', fallback);
      }
    };
  }, [element, callback]);
};
